<pre>{{ isInProgress }}</pre>
<div class="message" *ngIf="isInProgress">
  <div style="margin-bottom: 14px;">Uploading... {{ progress }}%</div>
</div>

<div class="container" fxLayout="column" fxLayoutAlign="space-evenly stretch">
  <h1 mat-dialog-title>Upload Files</h1>
  <div>
    <button
      [disabled]="isInProgress || completed"
      mat-raised-button
      color="primary"
      class="add-files-btn"
      (click)="addDocument()"
    >
      Add Files
    </button>
  </div>

  <!-- This is the content of the dialog, containing a list of the files to upload -->
  <form [formGroup]="documentForm">
    <mat-dialog-content fxFlex>
      <mat-list formArrayName="DocumentUploads">
        <mat-list-item
          *ngFor="
            let doc of documentForm.get('DocumentUploads')['controls'];
            index as i
          "
          [formGroupName]="i"
        >
          <input
            type="text"
            placeholder="Enter File Title"
            formControlName="FileTitle"
          />
          <input
            type="text"
            placeholder="Enter File Description"
            formControlName="FileDescription"
          />
          <h4 mat-line>{{ file.name }}</h4>
          <input
            type="file"
            #file
            (change)="onFilesAdded($event, i)"
            multiple
          />
          <mat-progress-bar
            *ngIf="isInProgress"
            mode="determinate"
            [value]="progress"
          ></mat-progress-bar>
        </mat-list-item>
      </mat-list>
    </mat-dialog-content>

    <!-- This are the actions of the dialog, containing the primary and the cancel button-->
    <mat-dialog-actions class="actions">
      <button *ngIf="isInProgress" mat-button mat-dialog-close>
        Cancel
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="uploadFile(documentForm.value)"
      >
        Submit
      </button>
    </mat-dialog-actions>
  </form>
</div>

<!-- <div class="message" *ngIf="(isReady$ | async) || (hasFailed$ | async)">
  <input #file type="file" multiple (change)="uploadFile($event)" />
</div>

<div class="message" *ngIf="isInProgress$ | async">
  <div style="margin-bottom: 14px;">Uploading... {{ progress$ | async }}%</div>
</div>
<pre>{{ isInProgress$ | async }}</pre>
<div class="message" *ngIf="isInProgress$ | async">
  <button (click)="cancelUpload()">Cancel Upload</button>
</div>

<div class="message" *ngIf="completed$ | async">
  <h4>
    File has been uploaded successfully!
  </h4>
  <button (click)="resetUpload()">Upload Another File</button>
</div>

<div class="message error" *ngIf="hasFailed$ | async">
  Error: {{ error$ | async }}
</div> -->
